<template>
    <v-container class="container" fluid>
        <v-data-table
            :headers="headers"
            :items="orders"
            item-key="OrderID"
            :search="search"
            class="elevation-10"
            :loading="dataLoading"
            loading-text="Loading... Please wait"
        >
            <template v-slot:top>
                <v-toolbar dark color="secondary" dense>
                    <v-spacer />
                    <v-toolbar-title class="white--text"
                        >Orders</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-title>
                    <v-text-field
                        v-model="search"
                        label="Search"
                        append-icon="mdi-magnify"
                        dense
                    >
                    </v-text-field>
                    <v-spacer />
                    <v-spacer />
                    <v-btn
                        fab
                        large
                        color="secondary"
                        icon
                        @click="toNewOrder"
                        exact
                    >
                        <v-icon large>mdi-plus-circle</v-icon>
                    </v-btn>
                </v-card-title>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small @click="edit(item)">mdi-pencil</v-icon>
                <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>
        <v-dialog v-model="dialog" max-width="350px">
            <v-card>
                <v-toolbar color="primary" dense>
                    <v-spacer />
                    <v-toolbar-title class="white--text">
                        Are you sure you want to delete?</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container class="px-10 py-5">
                    <v-row>
                        <v-btn color="success" @click="deleteOrder(index)"
                            >Aceptar</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn color="red" @click="dialog = false"
                            >Cancel</v-btn
                        >
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios';
export default {
    name: 'ShiftAssignments',
    data: function() {
        return {
            dialog: false,
            index: false,
            orders: [],
            headers: [
                { text: 'Order #', value: 'OrderID', width: '8%' },
                { text: 'Order Status', value: 'OrderStatus', width: '10%' },
                { text: 'Station', value: 'Station', width: '20%' },
                { text: 'Terminal', value: 'Terminal', width: '20%' },
                { text: 'Customer', value: 'Customer', width: '15%' },
                { text: 'Created by', value: 'Username', width: '10%' },
                {
                    text: 'Requested Date',
                    value: 'DateRequested',
                    width: '15%'
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    width: '8%'
                }
            ],
            search: '',
            dataLoading: false
        };
    },

    mounted() {
        this.loadOrders();
    },

    methods: {
        loadOrders: function() {
            //  this.$store.state.isLoading = true;
            this.dataLoading = true;
            
            axios
                .post('order/active',{}, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.orders = response.data;
                    console.log(this.orders);
                    this.dataLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        edit: function(item) {
            this.$store.state.isLoading = true;
            this.$store.state.editedOrder.destiny = 1;
            this.$store.state.editedOrder.id = item.OrderID;
            this.$store.state.isLoading = false;
            this.$router.push('/dispatch/orders/form');
        },
        deleteOrder: function(index) {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .delete('order/' + index, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    axios
                        .delete('order-detail/order/' + index, {
                            headers: {
                                Authorization:
                                    'Bearer ' + this.$store.state.token
                            }
                        })
                        // eslint-disable-next-line no-unused-vars
                        .then(response => {
                            this.loadOrders();
                            this.dialog = false;
                        })
                        .catch(function(error) {
                            console.log(error);
                            if (error.response.status === 403) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'You do not have the permission to use this function.'
                                });
                            }
                            if (error.response.status === 500) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'An error has ocurred, please try again.'
                                });
                            }
                        });
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        deleteItem: function(item) {
            this.index = item.OrderID;
            this.dialog = true;
        },
        toNewOrder: function() {
            this.$store.state.editedOrder.id = null;
            this.$store.state.editedOrder.StationID = null;
            this.$store.state.editedOrder.destiny = 1;
            this.$store.state.orderDialog = false;
            this.$router.push('/dispatch/orders/form');
        }
    }
};
</script>
